import {AriaListBoxOptions, useListBoxSection} from 'react-aria';
import {useListBox, useOption} from 'react-aria';
import React from "react";
import {Node} from '@react-types/shared';
import {ListState} from '@react-stately/list';
import {CheckIcon} from "@heroicons/react/20/solid";

interface ListBoxProps extends AriaListBoxOptions<unknown> {
    listBoxRef?: React.RefObject<HTMLUListElement>;
    state: ListState<unknown>;
}

interface SectionProps {
    section: Node<unknown>;
    state: ListState<unknown>;
}

export function ListBox(props: ListBoxProps) {

    const {label} = props;
    let ref = React.useRef<HTMLUListElement>(null);
    let {listBoxRef = ref, state} = props;
    let {listBoxProps, labelProps} = useListBox(props, state, listBoxRef);

    return (
        <>
            {label && (
                <label {...labelProps} className={`field-label`}>
                    {/*<label {...labelProps} className={`field-label ${isDisabled ? 'field-disabled' : ''}`}>*/}
                    {label}
                    {/*{isRequired && <span className={'field-required'}>*</span>}*/}
                </label>
            )}

            <ul {...listBoxProps} ref={listBoxRef} className={'field-listbox'}>
                {/*{Array.from(state.collection).map((item) => (*/}
                {/*    item.type === 'section'*/}
                {/*        ? <ListBoxSection key={item.key} section={item} state={state} />*/}
                {/*        : <Option key={item.key} item={item} state={state} />*/}
                {/*))}*/}
                {Array.from(state.collection).map((item) => (
                    item.type === 'section' ? (
                        <ListBoxSection key={item.key} section={item} state={state}/>
                    ) : (
                        <Option key={item.key} item={item} state={state}/>
                    )
                ))}
            </ul>
        </>
    );
}


function ListBoxSection({section, state}: SectionProps) {

    const {itemProps, headingProps, groupProps} = useListBoxSection({
        heading: section.rendered,
        'aria-label': section['aria-label']
    });

    return (
        <>
            {section.rendered && (
                <li {...itemProps} className="pt-2">
                    <div
                        {...headingProps}
                        className="px-3 py-1 text-xs font-semibold text-gray-500 uppercase tracking-wider bg-gray-50 sticky top-0 z-10"
                    >
                        {section.rendered}
                    </div>
                    <ul {...groupProps}>
                        {Array.from(section.childNodes).map((node) => (
                            <Option key={node.key} item={node} state={state}/>
                        ))}
                    </ul>
                </li>
            )}
            {!section.rendered && (
                <li {...itemProps}>
                    <ul {...groupProps}>
                        {Array.from(section.childNodes).map((node) => (
                            <Option key={node.key} item={node} state={state}/>
                        ))}
                    </ul>
                </li>
            )}
        </>
    );
}


// function ListBoxSection({ section, state }) {
//
//     const { itemProps, headingProps, groupProps } = useListBoxSection({
//         heading: section.rendered,
//         'aria-label': section['aria-label']
//     });
//
//     // If the section is not the first, add a separator element to provide visual separation.
//     // The heading is rendered inside an <li> element, which contains
//     // a <ul> with the child items.
//     return (
//         <>
//             {section.key !== state.collection.getFirstKey() &&
//                 (
//                     <li
//                         role="presentation"
//                         style={{
//                             borderTop: '1px solid gray',
//                             margin: '2px 5px'
//                         }}
//                     />
//                 )}
//             <li {...itemProps}>
//                 {section.rendered &&
//                     (
//                         <span
//                             {...headingProps}
//                             style={{
//                                 fontWeight: 'bold',
//                                 fontSize: '1.1em',
//                                 padding: '2px 5px'
//                             }}
//                         >
//               {section.rendered}
//             </span>
//                     )}
//                 <ul
//                     {...groupProps}
//                     style={{
//                         padding: 0,
//                         listStyle: 'none'
//                     }}
//                 >
//                     {[...section.childNodes].map((node) => (
//                         <Option
//                             key={node.key}
//                             item={node}
//                             state={state}
//                         />
//                     ))}
//                 </ul>
//             </li>
//         </>
//     );
// }


interface OptionProps<T> {
    item: Node<T>;
    state: ListState<T>;
}

export function Option<T>({item, state}: OptionProps<T>) {

    const ref = React.useRef(null);
    const {optionProps, isDisabled, isSelected, isFocused} = useOption({key: item.key}, state, ref);

    return (
        <li {...optionProps} ref={ref} data-focus-visible={isFocused} data-selected={isSelected}
            data-disabled={isDisabled}
            className={`field-listbox-option`}>
            {item.rendered}
            {isSelected && (
                <CheckIcon aria-hidden="true" className="w-4 h-4 text-pink-600"/>
            )}
        </li>
    );
}